const TRAFFIC_TICKET_VALIDATIONS = {
  trafficRegion: value => {
    if (!value) {
      return 'Please select a traffic region.'
    }
    return false
  },
  attorney: value => {
    if (!value || !value.length) {
      return 'Please select an attorney.'
    }
    return false
  },
  ticketID: value => {
    if (!value) {
      return false
    }
    if (!value.match(/^\w{6,15}$/)) {
      return 'Ticket ID needs to be 6 to 15 alphanumeric characters.'
    }
    return false
  },
  // This will be passed persistedImage value
  persistedTicketImage: value => {
    // REMOVED FOR FLOW UPDATES
    if (!value || !value.isImageAttached) {
      return 'A ticket image is required.'
    }
    return false
  },
  trafficCourt: value => {
    if (!value) return 'Please select the court listed on your ticket.'
    return false
  },
  violationName: value => {
    if (!value || !value.length)
      return 'Please select the violation listed on your ticket.'
    return false
  }
}

export default TRAFFIC_TICKET_VALIDATIONS
